import type { IMedium } from "@op/puck-types";
// @ts-ignore
import placeholderImage from "../../../../../assets/placeholder.svg?url&no-inline";
import {
  makeEditorImageUrl,
  makeRendererImageUrl,
  MediaPreview,
  useRender,
} from "@op/utils";
import { useMemo } from "react";

export interface MediumNonFigureProps {
  medium: IMedium;
  cover?: boolean;
}

export const MediumNonFigure = ({ medium, cover }: MediumNonFigureProps) => {
  const { context, apiUrl } = useRender();

  const imageUrl = useMemo(() => {
    if (!medium || !medium.uploadId) return "";
    switch (context) {
      case "editor":
        return makeEditorImageUrl(medium.uploadId, apiUrl);
      case "renderer":
        return makeRendererImageUrl(medium.uploadId, apiUrl);
      default:
        return "";
    }
  }, [context, apiUrl, medium]);

  const content = useMemo(() => {
    if (!imageUrl)
      return (
        <MediaPreview
          cover={cover}
          mimeType="image/svg+xml"
          src={placeholderImage}
          width={600}
          height={600}
          loading="eager"
        />
      );
    return (
      <MediaPreview
        cover={cover}
        src={imageUrl}
        alt={medium.metadata?.altText}
        mimeType={medium.mimeType}
        width={medium.width}
        height={medium.height}
        loading="eager"
        autoPlay={false}
      />
    );
  }, [imageUrl, medium]);

  return content;
};
